<template>
  <div class="delta-spin-page">
    <div v-if="showLoading" class="delta-spin-loading">
      <div class="delta-spin-loading__halo"></div>
      <img
        class="delta-spin-loading__logo"
        src="../assets/images/logo.png"
        width="116"
        alt="Delta Plus"
      >
      <p class="delta-spin-loading__label">กำลังเตรียมวงล้อแห่งโชค</p>
    </div>

    <div v-else class="delta-spin-shell">
      <headerSection />

      <main
        id="main__content"
        class="delta-spin-main"
        :style="{ backgroundImage: `url(${require('../assets/images/Shiba-BG.jpg')})` }"
      >
        <div class="delta-spin-main__veil"></div>
        <div class="delta-spin-main__aurora delta-spin-main__aurora--left"></div>
        <div class="delta-spin-main__aurora delta-spin-main__aurora--right"></div>
        <div class="delta-spin-main__stars" aria-hidden="true"></div>

        <section class="delta-fortune" aria-labelledby="delta-spin-title">
          <header class="delta-fortune__hero">
            <div class="delta-fortune__eyebrow">
              <span></span>
              DELTA FORTUNE CLUB
              <span></span>
            </div>
            <h1 id="delta-spin-title" class="delta-fortune__title">
              วงล้อ <strong>เดลต้า พลัส</strong>
            </h1>
            <p class="delta-fortune__subtitle">
              เสี่ยงโชคในค่ำคืนสีอเมทิสต์ สำหรับสมาชิกคนพิเศษ
            </p>
          </header>

          <div class="delta-fortune__card">
            <div class="delta-fortune__card-shine" aria-hidden="true"></div>

            <div class="delta-fortune__status">
              <div class="delta-fortune__quota">
                <span class="delta-fortune__status-label">สิทธิ์ประจำวัน</span>
                <strong>{{ canOpen ? 1 : 0 }}<small> / 1 ครั้ง</small></strong>
              </div>
              <div class="delta-fortune__availability">
                <span class="delta-fortune__status-dot"></span>
                {{ spinStatusText }}
              </div>
            </div>

            <DailyGameCondition :game="gameKey" :eligibility="rewardEligibility" :config="games_web" />
            <div class="delta-wheel-stage">
              <div class="delta-wheel-stage__glow" aria-hidden="true"></div>
              <div class="delta-wheel-stage__rim">
                <span
                  v-for="light in rimLights"
                  :key="light"
                  class="delta-wheel-stage__light"
                  :style="rimLightStyle(light)"
                ></span>

                <canvas
                  id="canvas"
                  ref="canvas"
                  class="delta-wheel-stage__canvas"
                  width="560"
                  height="560"
                  aria-label="วงล้อรางวัล Delta Plus"
                ></canvas>

                <div class="delta-wheel-stage__pointer" aria-hidden="true">
                  <span class="delta-wheel-stage__pointer-gem"></span>
                </div>

                <button
                  class="delta-wheel-stage__hub"
                  type="button"
                  :disabled="!canOpen || running"
                  :aria-label="spinButtonText"
                  @click="requestSpin"
                >
                  <span class="delta-wheel-stage__hub-mark">DP+</span>
                  <span class="delta-wheel-stage__hub-label">DELTA</span>
                </button>
              </div>
            </div>

            <button
              class="delta-fortune__spin-button"
              :class="{ 'delta-fortune__spin-button--ready': canOpen && !running }"
              type="button"
              :disabled="!canOpen || running"
              @click="requestSpin"
            >
              <span class="delta-fortune__spin-diamond">◆</span>
              {{ spinButtonText }}
              <span class="delta-fortune__spin-diamond">◆</span>
            </button>

            <p class="delta-fortune__message" :class="{ 'delta-fortune__message--notice': loadingtext }">
              {{ loadingtext || 'แตะ SPIN หรือปุ่มด้านล่างเพื่อเริ่มลุ้น' }}
            </p>
          </div>

          <p class="delta-fortune__terms">
            เงื่อนไขเป็นไปตามที่บริษัทกำหนด · รางวัลจะแสดงผลหลังวงล้อหยุด
          </p>
        </section>
      </main>

      <footerSection />
    </div>
  </div>
</template>
<script>
import DailyGameCondition from '../components/DailyGameCondition.vue'
import { dailyGameCopy } from '../utils/dailyGameCopy'
import firebase, { database } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import _ from 'lodash'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'
const axios = require('axios').default
require('vue2-animate/dist/vue2-animate.min.css')
// @ is an alias to /src
export default {
  name: 'Gift',
  components: {
    DailyGameCondition,
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  created () {
    const user = localStorage.getItem('userData')
	  if (user) {
		  const _user = JSON.parse(user)
		  this.$store.dispatch('user/setUser', _user).then(()=>{
        this.checkUserId()
      }).catch(err => { console.error(err) })
	  } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
	  }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    dailyGameText () { return dailyGameCopy(this.rewardEligibility, this.games_web, this.gameKey) },
    user () {
      return this.$store.state.user.user
    },
    spinStatusText () {
      if (this.running) {
        return 'กำลังหมุนวงล้อ'
      }
      return this.canOpen ? 'พร้อมรับโชค' : 'กำลังตรวจสอบสิทธิ์'
    },
    spinButtonText () {
      if (this.running) {
        return 'กำลังหมุน'
      }
      return this.canOpen ? 'หมุนรับโชค' : 'ยังไม่พร้อมหมุน'
    }
  },
  mounted () {
      //this.animSplashScreen.play()
      setTimeout(() => {
        this.showLoading = false
       // this.animSplashScreen.stop()
        setTimeout(() => {
          this.canvas = this.$refs.canvas
          this.repaint(this.angle)
          window.addEventListener('resize', this.handleWheelResize)
        }, 500)
      }, 3500)
      this.getGames()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWheelResize)
    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame)
    }
  },
  data () {
    return {
      logoLeft: '',
      logoRight: '',
      angle: 0,
      gameKey: 'spin',
      showLoading: true,
      pictureUrl: '',
      code: '',
      games_web: [],
      search: '',
      loading: false,
      error: false,
      web: [],
      message: 'Invalid user name or password!',
      point: 0,
      favorites: [],
      animationInfinite: {
        classes: 'fadeIn',
        duration: 5000,
        iteration: 'infinite'
      },
      permission: [],
      defaultOptions: null,
      defaultOptions2: null,
      defaultOptionsSplashScreen: null,
      openGiftData: false,
      canOpen: false,
      rewardEligibility: null,
      percentage: 0,
      loadingtext: '',
      credit: '',
      save: false,
      canvas: null,
      frame: null,
      wheels: null,
      wheelSize: 0,
      resizeFrame: null,
      running: false,
      rimLights: Array.from({ length: 24 }, (item, index) => index),
      sections: [],
      sectionspoint: [],
      colors: [],
      percent: []
    }
  },
  methods: {
    rimLightStyle (light) {
      const angle = light / this.rimLights.length * Math.PI * 2 - Math.PI / 2
      const radius = 47
      return {
        left: `${50 + Math.cos(angle) * radius}%`,
        top: `${50 + Math.sin(angle) * radius}%`,
        animationDelay: `${(light % 4) * 0.16}s`
      }
    },
    requestSpin () {
      if (this.canvas && this.canOpen && !this.running && typeof this.canvas.onmousedown === 'function') {
        this.canvas.onmousedown()
      }
    },
    handleWheelResize () {
      if (!this.canvas || this.running) {
        return
      }
      if (this.resizeFrame) {
        cancelAnimationFrame(this.resizeFrame)
      }
      this.resizeFrame = requestAnimationFrame(() => {
        this.wheels = null
        this.frame = null
        this.wheelSize = 0
        this.repaint(this.angle)
        this.resizeFrame = null
      })
    },
    // handleAnimationSplashScreen: function (anim) {
    //   this.animSplashScreen = anim
    // },
    async getGames () {
      this.games_web = (await firebase.database().ref('/spin').once('value')).val()
    },
    async checkUserId () {
      this.canOpen = false
      try {
        const response = await axios.post('https://api.deltaplus-dp.com/qspin/eligibility', { key: this.user.key, code: this.user.code })
        this.rewardEligibility = response.data
        this.canOpen = Boolean(response.data.canOpen && !response.data.alreadyPlayed)
        this.loadingtext = response.data.disabled ? 'เกมปิดให้บริการชั่วคราว' : response.data.alreadyPlayed ? 'ใช้สิทธิ์วันนี้แล้ว กลับมาใหม่วันพรุ่งนี้' : this.canOpen ? 'พร้อมหมุนรับรางวัล' : this.dailyGameText.missing
      } catch (error) {
        this.loadingtext = 'ตรวจสอบสิทธิ์ไม่สำเร็จ กรุณาโหลดหน้าใหม่อีกครั้ง'
      }
    },
    checkCssBox (game) {
      if (!game.status) {
        return 'box-shadow: 0 0 12px 5px #cccccc;border: 2px solid #cccccc;'
      }
    },
    checkCss (game) {
      if (!this.permission || !this.permission[game.key]) {
        return 'filter: grayscale(100%);'
      }
      // const index = _.findIndex(this.favorites, function(o) { return o == code; });
      // if (index>-1) {
      //   return '';
      // } else {
      //   return 'filter: grayscale(100%);';
      // }
    },
    goto (type) {
      if (type === 'home') {
        // window.scrollTo({
        //   top: 0,
        //   left: 0,
        //   behavior: 'smooth'
        // });
        this.$router.push('/').catch(() => {})
      } else if (type === 'website') {
        window.location = this.web.link
        // this.gotoline()
      } else if (type === 'contact') {
        window.location = this.web.link_line
        // this.gotoline()
      }
    },
    repaint (angle) {
      if (this.games_web && this.sections.length === 0) {
        let ty = 'เครดิต'
        if (this.games_web.type !== 'credit') {
          ty = 'คะแนน'
        }
        const displaySlots = [13, 1, 2, 3, 4, 5, 6, 7, 'visual-10', 8, 9, 10, 11, 12]
        displaySlots.forEach((slot, index) => {
          const sourceSlot = slot === 'visual-10' ? 10 : slot
          if (this.games_web[`spin${sourceSlot}slot`]) {
            this.sections.push('สูตร ' + this.games_web[`spin${sourceSlot}`] + ' ชั่วโมง')
            this.sectionspoint.push('สูตร ' + this.games_web[`spin${sourceSlot}`] + ' ชั่วโมง')
          } else {
            this.sections.push(this.games_web[`spin${sourceSlot}`] + ' ' + ty)
            this.sectionspoint.push(this.games_web[`spin${sourceSlot}`])
          }

          this.colors.push(index % 2 === 0 ? '#8e2bc1' : '#fffafc')
          if (slot !== 'visual-10' && this.games_web[`spin${sourceSlot}percent`]) {
            for (let p = 1; p <= this.games_web[`spin${sourceSlot}percent`]; p++) {
              // if (this.games_web[`spin${j}slot`]) {
              //   this.percent.push('สูตร ' + this.games_web[`spin${j}`] + ' ชั่วโมง')
              // } else {
                this.percent.push(this.games_web[`spin${sourceSlot}`])
              //}
            }
          }
        })
      }
      if (!this.canvas || this.sections.length === 0) {
        return
      }

      const parentWidth = this.canvas.parentElement ? this.canvas.parentElement.clientWidth : 560
      const size = Math.max(280, Math.min(parentWidth, 600))
      const r = Math.floor(size * 0.405)
      if (this.wheelSize !== size) {
        this.wheelSize = size
        this.wheels = null
        this.frame = null
      }

      if (this.wheels === null) {
        this.wheels = []
        for (let selected = 0; selected < this.sections.length; selected++) {
          const c = document.createElement('canvas')
          c.width = c.height = size
          const ctx = c.getContext('2d')
          const cx = size / 2
          const cy = size / 2
          const arc = 2 * Math.PI / this.sections.length

          for (let i = 0; i < this.sections.length; i++) {
            const a0 = arc * i
            const a1 = a0 + arc
            const a = arc * (i + 0.5)
            const isPurple = i % 2 === 0
            const segmentGradient = ctx.createLinearGradient(
              cx + Math.cos(a) * r * 0.15,
              cy + Math.sin(a) * r * 0.15,
              cx + Math.cos(a) * r,
              cy + Math.sin(a) * r
            )
            if (isPurple) {
              segmentGradient.addColorStop(0, '#d466f2')
              segmentGradient.addColorStop(0.55, '#922fc8')
              segmentGradient.addColorStop(1, '#4b0b7a')
            } else {
              segmentGradient.addColorStop(0, '#ffffff')
              segmentGradient.addColorStop(0.62, '#f6effa')
              segmentGradient.addColorStop(1, '#d9c9e4')
            }

            ctx.beginPath()
            ctx.moveTo(cx, cy)
            ctx.arc(cx, cy, r, a0, a1, false)
            ctx.closePath()
            ctx.fillStyle = segmentGradient
            ctx.fill()
            ctx.strokeStyle = isPurple ? 'rgba(255,255,255,0.58)' : 'rgba(92,27,126,0.38)'
            ctx.lineWidth = Math.max(1, r * 0.009)
            ctx.stroke()

            const sheen = ctx.createRadialGradient(cx, cy, r * 0.08, cx, cy, r)
            sheen.addColorStop(0, 'rgba(255,255,255,0.34)')
            sheen.addColorStop(0.68, 'rgba(255,255,255,0)')
            sheen.addColorStop(1, 'rgba(19,0,31,0.15)')
            ctx.fillStyle = sheen
            ctx.fill()

            if (i === selected) {
              ctx.save()
              ctx.beginPath()
              ctx.moveTo(cx, cy)
              ctx.arc(cx, cy, r * 0.99, a0, a1, false)
              ctx.closePath()
              ctx.fillStyle = 'rgba(255,255,255,0.15)'
              ctx.shadowColor = '#f4c9ff'
              ctx.shadowBlur = r * 0.08
              ctx.fill()
              ctx.restore()
            }

            ctx.save()
            const check = this.sections[i].split(' ')
            const isFormula = check[0] === 'สูตร'
            const amount = isFormula ? check.slice(0, 2).join(' ') : check[0]
            const unit = isFormula ? 'ชั่วโมง' : (this.games_web.type === 'credit' ? 'COIN' : 'POINT')
            const amountSize = Math.max(15, Math.floor(r / (isFormula ? 12.8 : 10.8)))
            const unitSize = Math.max(8, Math.floor(r / 24))

            ctx.translate(cx, cy)
            ctx.rotate(a + Math.PI / 2)
            ctx.translate(0, -r * 0.67)
            ctx.fillStyle = isPurple ? '#ffffff' : '#2c1239'
            ctx.shadowColor = isPurple ? 'rgba(39,0,60,0.78)' : 'rgba(255,255,255,0.82)'
            ctx.shadowBlur = Math.max(1, r * 0.014)
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.font = `900 ${amountSize}px Kanit, sans-serif`
            ctx.fillText(amount, 0, -unitSize * 0.42)
            ctx.font = `700 ${unitSize}px Kanit, sans-serif`
            ctx.letterSpacing = '0.08em'
            ctx.fillText(unit, 0, unitSize * 0.82)
            ctx.restore()
          }

          const centerGlow = ctx.createRadialGradient(cx, cy, 0, cx, cy, r * 0.34)
          centerGlow.addColorStop(0, 'rgba(255,255,255,0.5)')
          centerGlow.addColorStop(0.5, 'rgba(137,41,190,0.3)')
          centerGlow.addColorStop(1, 'rgba(54,5,78,0)')
          ctx.fillStyle = centerGlow
          ctx.beginPath()
          ctx.arc(cx, cy, r * 0.34, 0, Math.PI * 2)
          ctx.fill()

          this.wheels.push(c)
        }
      }
      if (this.frame === null) {
        this.frame = document.createElement('canvas')
        this.frame.width = this.frame.height = size
        const ctx = this.frame.getContext('2d')
        const cx = size / 2
        const cy = size / 2
        const ringGradient = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r)
        ringGradient.addColorStop(0, '#f8eaff')
        ringGradient.addColorStop(0.16, '#9a45c2')
        ringGradient.addColorStop(0.38, '#3b0c59')
        ringGradient.addColorStop(0.58, '#f5d8ff')
        ringGradient.addColorStop(0.76, '#6d1b99')
        ringGradient.addColorStop(1, '#ffffff')

        ctx.save()
        ctx.shadowColor = 'rgba(78,12,112,0.72)'
        ctx.shadowBlur = r * 0.12
        ctx.beginPath()
        ctx.arc(cx, cy, r * 1.075, 0, Math.PI * 2)
        ctx.strokeStyle = ringGradient
        ctx.lineWidth = r * 0.13
        ctx.stroke()
        ctx.restore()

        ctx.beginPath()
        ctx.arc(cx, cy, r * 1.008, 0, Math.PI * 2)
        ctx.strokeStyle = 'rgba(255,255,255,0.88)'
        ctx.lineWidth = Math.max(2, r * 0.018)
        ctx.stroke()

        ctx.beginPath()
        ctx.arc(cx, cy, r * 1.142, 0, Math.PI * 2)
        ctx.strokeStyle = 'rgba(201,137,233,0.52)'
        ctx.lineWidth = Math.max(1, r * 0.012)
        ctx.stroke()
      }

      this.canvas.width = size
      this.canvas.height = size
      const cx = size / 2
      const cy = size / 2
      const ctx = this.canvas.getContext('2d')
      let selected = (Math.floor((-0.2 - angle) * this.sections.length / (2 * Math.PI)) %
                        this.sections.length)
      if (selected < 0) selected += this.sections.length

      ctx.clearRect(0, 0, size, size)
      ctx.save()
      ctx.translate(cx, cy)
      ctx.rotate(angle - Math.PI / 2 + 0.2)
      ctx.translate(-size / 2, -size / 2)
      ctx.drawImage(this.wheels[selected], 0, 0)
      ctx.restore()
      ctx.drawImage(this.frame, 0, 0)
      if (this.canOpen) {
        this.canvas.onmousedown = async () => {
          if (!this.running && this.canOpen) {
            this.running = true
            this.canOpen = false
            // console.log(Math.floor(Math.random() * this.percent.length));
            const r = Math.floor(Math.random() * this.percent.length)
            const item = this.percent[r]
            const rands = []
            for (const x in this.sectionspoint) {
              if (this.sectionspoint[x] === item) {
                // console.log('this.numorder[x]='+this.sectionspoint[x]+'=x='+x+'=item='+item);
                rands.push(x)
              }
            }
            const rand = Math.floor(Math.random() * rands.length)
            try {
              await axios.post('https://api.deltaplus-dp.com/qspin/spin', { key: this.user.key, code: this.user.code, credit: item })
              this.spinTo(Number(rands[rand]), 5000)
            } catch (error) {
              this.running = false
              this.loadingtext = 'รับรางวัลไม่สำเร็จ กรุณาโหลดหน้าใหม่เพื่อตรวจสอบสิทธิ์อีกครั้ง'
            }
          }
        }
      }
    },
    spinTo (winner, duration) {
      this.canOpen = false
      const finalAngle = (-0.2) - (0.5 + winner) * 2 * Math.PI / this.sections.length
      const startAngle = this.angle - Math.floor(this.angle / (2 * Math.PI)) * 2 * Math.PI - 5 * 2 * Math.PI
      const start = performance.now()
      const frame = () => {
        const now = performance.now()
        let t = Math.min(1, (now - start) / duration)
        t = 3 * t * t - 2 * t * t * t // ease in out
        this.angle = startAngle + t * (finalAngle - startAngle)
        this.repaint(this.angle)
        if (t < 1) requestAnimationFrame(frame); else {
          const coin = this.sections[winner].split(' ')
          if (Number(coin[0]) > 0) {
            // this.mycoin += Number(coin[0]);
            this.$confirm(
              {
                message: `🎡 ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘`,
                button: {
                  yes: 'OK'
                },
                callback: confirm => {
                  if (confirm) {
                    // this.getUserId()
                  }
                }
              }
            )
          } else if (coin[0] === 'สูตร') {
            this.$confirm(
              {
                message: `🎡 ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘`,
                button: {
                  yes: 'OK'
                },
                callback: confirm => {
                  if (confirm) {
                    // this.getUserId()
                  }
                }
              }
            )
          }
        }
      }
      requestAnimationFrame(frame)
      this.running = true
    }

  }
}
</script>
<style scoped>
.delta-spin-page {
  --delta-ink: #190621;
  --delta-deep: #2a0737;
  --delta-purple: #8324b8;
  --delta-violet: #bf52e4;
  --delta-lilac: #edc8fa;
  --delta-pearl: #fffafd;
  min-height: 100vh;
  background: #120318;
  color: var(--delta-pearl);
  font-family: 'Kanit', sans-serif;
}

.delta-spin-loading {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 44%, rgba(183, 70, 226, 0.3), transparent 27%),
    linear-gradient(155deg, #08010b 0%, #21052c 52%, #0d0211 100%);
}

.delta-spin-loading__halo {
  position: absolute;
  width: 230px;
  height: 230px;
  border: 1px solid rgba(238, 200, 250, 0.28);
  border-radius: 50%;
  box-shadow:
    0 0 45px rgba(190, 75, 229, 0.45),
    inset 0 0 45px rgba(190, 75, 229, 0.26);
  animation: delta-loading-pulse 1.8s ease-in-out infinite;
}

.delta-spin-loading__logo {
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 0 18px rgba(228, 153, 255, 0.58));
}

.delta-spin-loading__label {
  position: relative;
  z-index: 1;
  margin: 20px 0 0;
  color: #f4ddfb;
  font-size: 0.88rem;
  font-weight: 400;
  letter-spacing: 0.07em;
}

.delta-spin-main {
  position: relative;
  min-height: calc(100vh - 72px);
  overflow: hidden;
  padding: 38px 18px 150px;
  background-position: center top;
  background-size: cover;
  isolation: isolate;
}

.delta-spin-main__veil {
  position: absolute;
  z-index: -3;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(18, 3, 24, 0.76) 0%, rgba(40, 8, 52, 0.84) 48%, rgba(10, 2, 14, 0.94) 100%),
    radial-gradient(circle at 50% 36%, rgba(160, 55, 203, 0.34), transparent 46%);
  backdrop-filter: saturate(0.8);
}

.delta-spin-main__aurora {
  position: absolute;
  z-index: -2;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  filter: blur(28px);
  opacity: 0.42;
  pointer-events: none;
}

.delta-spin-main__aurora--left {
  top: 16%;
  left: -330px;
  background: radial-gradient(circle, rgba(199, 75, 234, 0.72), transparent 66%);
}

.delta-spin-main__aurora--right {
  top: 42%;
  right: -360px;
  background: radial-gradient(circle, rgba(99, 39, 177, 0.76), transparent 66%);
}

.delta-spin-main__stars {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.7;
  pointer-events: none;
  background-image:
    radial-gradient(circle, rgba(255, 255, 255, 0.9) 0 1px, transparent 1.8px),
    radial-gradient(circle, rgba(231, 184, 249, 0.74) 0 1px, transparent 1.6px);
  background-position: 12px 18px, 82px 70px;
  background-size: 122px 122px, 173px 173px;
  mask-image: linear-gradient(to bottom, transparent, #000 16%, #000 84%, transparent);
}

.delta-fortune {
  position: relative;
  z-index: 1;
  width: min(100%, 760px);
  margin: 0 auto;
}

.delta-fortune__hero {
  text-align: center;
  animation: delta-rise 0.7s ease both;
}

.delta-fortune__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #eac5f8;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 0.77rem;
  font-weight: 700;
  letter-spacing: 0.28em;
  text-transform: uppercase;
}

.delta-fortune__eyebrow span {
  width: clamp(30px, 8vw, 72px);
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(236, 196, 250, 0.9));
}

.delta-fortune__eyebrow span:last-child {
  transform: scaleX(-1);
}

.delta-fortune__title {
  margin: 10px 0 0;
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: clamp(2.15rem, 7vw, 3.8rem);
  font-weight: 700;
  line-height: 1.06;
  letter-spacing: -0.035em;
  text-shadow:
    0 2px 0 rgba(64, 9, 86, 0.78),
    0 0 26px rgba(214, 126, 244, 0.32);
}

.delta-fortune__title strong {
  color: #e7b7f7;
  font-weight: 800;
  background: linear-gradient(180deg, #ffffff 0%, #e9b8f8 46%, #bc54df 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.delta-fortune__subtitle {
  margin: 10px auto 24px;
  color: rgba(252, 238, 255, 0.72);
  font-size: clamp(0.85rem, 2.6vw, 1rem);
  font-weight: 300;
}

.delta-fortune__card {
  position: relative;
  overflow: hidden;
  padding: 22px 22px 28px;
  border: 1px solid rgba(229, 181, 246, 0.5);
  border-radius: 34px;
  background:
    linear-gradient(145deg, rgba(73, 19, 95, 0.92), rgba(25, 6, 34, 0.97)),
    rgba(26, 6, 35, 0.94);
  box-shadow:
    0 26px 70px rgba(4, 0, 6, 0.56),
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    inset 0 0 58px rgba(166, 58, 207, 0.12);
  animation: delta-rise 0.78s 0.08s ease both;
}

.delta-fortune__card::before,
.delta-fortune__card::after {
  position: absolute;
  z-index: 0;
  border: 1px solid rgba(225, 177, 243, 0.2);
  border-radius: 26px;
  content: '';
  inset: 10px;
  pointer-events: none;
}

.delta-fortune__card::after {
  border-color: rgba(129, 41, 165, 0.38);
  inset: 15px;
}

.delta-fortune__card-shine {
  position: absolute;
  z-index: 0;
  top: -160px;
  left: 12%;
  width: 76%;
  height: 280px;
  border-radius: 50%;
  background: rgba(220, 131, 247, 0.13);
  filter: blur(28px);
  pointer-events: none;
}

.delta-fortune__status {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 2px 16px 8px;
}

.delta-fortune__quota {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #fff;
}

.delta-fortune__status-label {
  color: rgba(245, 223, 251, 0.62);
  font-size: 0.78rem;
  font-weight: 400;
}

.delta-fortune__quota strong {
  color: #e6b2f4;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 1.8rem;
  line-height: 1;
}

.delta-fortune__quota small {
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
}

.delta-fortune__availability {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 250, 253, 0.8);
  font-size: 0.8rem;
  white-space: nowrap;
}

.delta-fortune__status-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e7b7f7;
  box-shadow: 0 0 14px #d772f2;
  animation: delta-dot 1.5s ease-in-out infinite;
}

.delta-wheel-stage {
  position: relative;
  z-index: 2;
  width: min(100%, 600px);
  margin: 0 auto;
  aspect-ratio: 1;
}

.delta-wheel-stage__glow {
  position: absolute;
  z-index: -1;
  inset: 11%;
  border-radius: 50%;
  background: rgba(178, 70, 219, 0.32);
  box-shadow:
    0 0 70px rgba(192, 77, 228, 0.48),
    0 0 120px rgba(120, 41, 161, 0.3);
  filter: blur(18px);
}

.delta-wheel-stage__rim {
  position: relative;
  width: 100%;
  height: 100%;
}

.delta-wheel-stage__canvas {
  position: absolute;
  z-index: 2;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  cursor: pointer;
  filter: drop-shadow(0 18px 24px rgba(5, 0, 9, 0.54));
}

.delta-wheel-stage__light {
  position: absolute;
  z-index: 4;
  width: clamp(5px, 1.65vw, 10px);
  height: clamp(5px, 1.65vw, 10px);
  border: 1px solid rgba(92, 24, 123, 0.2);
  border-radius: 50%;
  background: #fff;
  box-shadow:
    0 0 7px #fff,
    0 0 14px #eaaeff,
    0 0 23px rgba(202, 101, 236, 0.9);
  transform: translate(-50%, -50%);
  animation: delta-bulb 1.15s ease-in-out infinite alternate;
  pointer-events: none;
}

.delta-wheel-stage__pointer {
  position: absolute;
  z-index: 7;
  top: 3.1%;
  left: 50%;
  width: 13.5%;
  height: 20%;
  transform: translateX(-50%);
  clip-path: polygon(18% 0, 82% 0, 100% 25%, 50% 100%, 0 25%);
  background: linear-gradient(145deg, #f4e7f9 0%, #9c46c6 18%, #4a0c6e 56%, #c05be3 100%);
  filter: drop-shadow(0 7px 8px rgba(21, 2, 31, 0.62));
  pointer-events: none;
}

.delta-wheel-stage__pointer::before {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.65);
  clip-path: inherit;
  content: '';
  inset: 4px;
}

.delta-wheel-stage__pointer-gem {
  position: absolute;
  top: 10%;
  left: 50%;
  width: 32%;
  padding-top: 32%;
  border: 1px solid rgba(255, 255, 255, 0.86);
  transform: translateX(-50%) rotate(45deg);
  background: linear-gradient(135deg, #fff 0 48%, #dca1ef 50% 100%);
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.78);
}

.delta-wheel-stage__hub {
  position: absolute;
  z-index: 6;
  top: 50%;
  left: 50%;
  display: flex;
  width: 27%;
  height: 27%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: clamp(3px, 0.8vw, 6px) solid rgba(249, 230, 255, 0.92);
  border-radius: 50%;
  outline: 2px solid rgba(90, 19, 120, 0.78);
  transform: translate(-50%, -50%);
  background:
    radial-gradient(circle at 36% 28%, #ffffff 0 3%, transparent 4%),
    radial-gradient(circle at 38% 32%, #ce83e8 0%, #852cb1 40%, #40085d 74%, #20032c 100%);
  box-shadow:
    0 7px 20px rgba(15, 0, 22, 0.66),
    inset 0 0 24px rgba(255, 255, 255, 0.27),
    0 0 0 5px rgba(100, 25, 132, 0.64);
  color: #fff;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.delta-wheel-stage__hub:not(:disabled):active {
  transform: translate(-50%, -50%) scale(0.96);
}

.delta-wheel-stage__hub:disabled {
  cursor: default;
  filter: saturate(0.72);
}

.delta-wheel-stage__hub-mark {
  font-family: Georgia, 'Times New Roman', serif;
  font-size: clamp(1.25rem, 6vw, 2.35rem);
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.07em;
  text-shadow: 0 2px 5px rgba(27, 2, 38, 0.6);
}

.delta-wheel-stage__hub-label {
  margin-top: 7px;
  color: #ecc9f8;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: clamp(0.42rem, 1.6vw, 0.7rem);
  font-weight: 700;
  letter-spacing: 0.24em;
}

.delta-fortune__spin-button {
  position: relative;
  z-index: 3;
  display: flex;
  width: min(78%, 370px);
  min-height: 60px;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: -2px auto 0;
  border: 1px solid rgba(241, 210, 251, 0.64);
  border-radius: 999px;
  background: linear-gradient(180deg, #772697 0%, #4c105f 54%, #2b0737 100%);
  box-shadow:
    0 10px 24px rgba(12, 0, 18, 0.48),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);
  color: rgba(255, 250, 253, 0.78);
  font-family: 'Kanit', sans-serif;
  font-size: clamp(1.05rem, 3.8vw, 1.32rem);
  font-weight: 700;
  letter-spacing: 0.03em;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.delta-fortune__spin-button--ready {
  background: linear-gradient(180deg, #bf59dd 0%, #8428ad 44%, #53106b 100%);
  box-shadow:
    0 12px 28px rgba(65, 10, 87, 0.62),
    0 0 22px rgba(214, 112, 240, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
  color: #fff;
  cursor: pointer;
}

.delta-fortune__spin-button--ready:hover {
  transform: translateY(-2px);
  filter: brightness(1.08);
}

.delta-fortune__spin-button--ready:active {
  transform: translateY(1px);
}

.delta-fortune__spin-button:disabled {
  cursor: default;
}

.delta-fortune__spin-diamond {
  color: #f1d2fb;
  font-size: 0.66em;
  text-shadow: 0 0 12px #e293fb;
}

.delta-fortune__message {
  position: relative;
  z-index: 3;
  margin: 16px 0 0;
  color: rgba(246, 228, 251, 0.62);
  font-size: clamp(0.74rem, 2.4vw, 0.88rem);
  font-weight: 300;
  text-align: center;
}

.delta-fortune__message--notice {
  color: #fff;
  font-weight: 400;
  text-shadow:
    0 0 10px rgba(226, 161, 248, 0.9),
    0 0 22px rgba(171, 62, 211, 0.65);
}

.delta-fortune__terms {
  margin: 15px 0 0;
  color: rgba(241, 215, 249, 0.42);
  font-size: 0.68rem;
  font-weight: 300;
  letter-spacing: 0.02em;
  text-align: center;
}

@keyframes delta-loading-pulse {
  0%,
  100% {
    opacity: 0.55;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

@keyframes delta-rise {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes delta-dot {
  0%,
  100% {
    opacity: 0.55;
    transform: scale(0.82);
  }
  50% {
    opacity: 1;
    transform: scale(1.12);
  }
}

@keyframes delta-bulb {
  from {
    opacity: 0.56;
    transform: translate(-50%, -50%) scale(0.78);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.08);
  }
}

@media (max-width: 575.98px) {
  .delta-spin-main {
    min-height: calc(100vh - 56px);
    padding: 28px 9px 126px;
  }

  .delta-fortune__eyebrow {
    gap: 9px;
    font-size: 0.62rem;
    letter-spacing: 0.2em;
  }

  .delta-fortune__title {
    margin-top: 7px;
    font-size: clamp(2rem, 11vw, 2.75rem);
  }

  .delta-fortune__subtitle {
    width: 88%;
    margin-bottom: 17px;
  }

  .delta-fortune__card {
    padding: 16px 7px 23px;
    border-radius: 26px;
  }

  .delta-fortune__card::before {
    border-radius: 20px;
    inset: 7px;
  }

  .delta-fortune__card::after {
    border-radius: 17px;
    inset: 11px;
  }

  .delta-fortune__status {
    align-items: center;
    padding: 2px 17px 3px;
  }

  .delta-fortune__quota strong {
    font-size: 1.52rem;
  }

  .delta-fortune__availability {
    max-width: 48%;
    justify-content: flex-end;
    font-size: 0.7rem;
    text-align: right;
    white-space: normal;
  }

  .delta-wheel-stage {
    width: 100%;
  }

  .delta-wheel-stage__light {
    width: 6px;
    height: 6px;
  }

  .delta-fortune__spin-button {
    width: 74%;
    min-height: 52px;
    gap: 11px;
    margin-top: -1px;
  }

  .delta-fortune__message {
    padding: 0 15px;
  }

  .delta-fortune__terms {
    padding: 0 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .delta-fortune__hero,
  .delta-fortune__card,
  .delta-spin-loading__halo,
  .delta-fortune__status-dot,
  .delta-wheel-stage__light {
    animation: none;
  }
}
</style>
